import { TextField, UrlField } from 'react-admin'
import { Box, Typography, TypographyProps, styled, Paper } from '@mui/material'
import { ImageField } from '../../fields/ImageField'

export const Heading: React.FC<TypographyProps> = ({ children, ...props }) => {
  return (
    <Typography variant='h6' sx={{ color: '#ADB3BD', fontWeight: 'normal' }} {...props}>
      {children}
    </Typography>
  )
}

export const TextFieldStyled = styled(TextField)(({ theme }) => ({
  color: '#000000',
  fontWeight: 'normal',
  fontSize: theme.typography.subtitle1.fontSize,
}))

export const UrlFieldStyled = styled(UrlField)(({ theme }) => ({
  fontWeight: 'normal',
  fontSize: theme.typography.subtitle1.fontSize,
}))

export const PreviewImage = styled(ImageField)(() => ({
  '& .RaImageField-image': {
    width: '100%',
    height: 300,
    objectFit: 'cover',
    borderRadius: 5,
  },
}))

export const PaperStyled = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  textAlign: 'center',
  color: theme.palette.text.secondary,
  height: 300,
  width: '100%',
  lineHeight: '60px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& .RaImageField-image': {
    verticalAlign: 'middle',
  },
}))

export const ContentWrapper = styled(Box)(() => ({ display: 'block', mb: 3 }))
